/**
 * Get all attributes from an HTML element using JQuery
 * 
 * @example $('#some_id').getAttributes()
 */
(function($)
{
	$.fn.getAttributes = function()
	{
		var attributes = {};

		if (!this.length)
		{
			return this;
		}

		$.each(this[0].attributes, function(index, attr)
		{
			attributes[attr.name] = attr.value;
		});

		return attributes;
	};
})(jQuery);

var GlobalList = new function()
{
	this.Lists = new function()
	{
	};

	this.AddList = function(List)
	{
		if (this.Lists[List.Name])
		{
			this.RemoveList(List.Name);
		}
		this.Lists[List.Name] = List;
	};

	this.GetList = function(ListName)
	{
		return this.Lists[ListName];
	};

	this.RemoveList = function(ListName)
	{
		// remove this node from the NodeList in Operations.js
		RemoveNode(ListName);
		if (undefined !== this.Lists[ListName])
		{
			// remove this node from this.Lists
			delete this.Lists[ListName];
		}
	};

	// deprecated
	// This function (GlobalList.OnLoad()) is called from javascript:OnLoad in
	// BODY tags
	// Only call this function if InitializeNodes() is not called.
	this.OnLoad = function()
	{
		for ( var ListName in this.Lists)
		{
			this.Lists[ListName].OnLoad();
		}
	};

	this.OnResize = function()
	{
		for ( var i in this.Lists)
		{
			this.Lists[i].OnResize();
		}
	};
};

function RemoveUndefinedArrayElements(targetArray)
{
	var newArray = new Array();
	for ( var i = 0; i < targetArray.length; i++)
	{
		if (targetArray[i])
		{
			newArray.push(targetArray[i]);
		}
	}
	return newArray;
}

function cList(Name, PALMode)
{
	var self = this;
	this.Name = Name;
	this.PALMode = PALMode;
	this.DEBUG_SAVE = false;
	// when set use the ctrl key for sorting a cList html table
	// TODO: RK_UPDATE_FOR_SIDE_BY_SIDE_SEARCH [leave code in place as disabled
	// feature]
	this.CTRL_KEY_MULTICOLUMN_ENABLED = false;
	this.InputParametersEnumeration =
	{
		HTML_INPUTS : 0,
		SAVE_PARMS : 1,
		TABLE_NAME : 2,
		LIST_NAME : 3,
		PRIMARY_KEYS : 4,
		DO_SAVE_PASS : 5,
		NODE_NAME : 6,
		READ_ONLY : 7,
		SQL_COLUMN : 8,
		DATA_ROW_INDEX : 9,
		UPDATE_OR_SAVE : 10,
		DATAVIEW_NAME : 11,
		RFC : 12,
		ESIG : 13
	};
	this.UpdateSaveEnumeration =
	{
		SAVE : 0,
		UPDATE : 1
	};

	RegisterNode(this);

	GlobalList.AddList(this);

	// cList
	this.OnLoad = function()
	{
		if (this.DEBUG_SAVE)
		{
			console.info('{cList:OnLoad}  Setting Up cList JS Object');
		}
		this.Attach();
		this.UpdateBulkActions();
		this.OnResize();
		this.EnableControls();
		this.SetPageNumbers();
		this.RegisterUpdates();
		this.SetSelectedIds();
		this.AutoViewSelectedImages();
		this.LoadImages();
		this.LimitLength("field", 75);
		// this.CheckForExpansions();

		if (this.PALMode == false)
		{
			leica.pi.esm.floatingHeaders.listHeader.run(this.Name);
		}
	};

	// cList
	this.Attach = function()
	{
		this.RootNode = document.getElementById(this.Name);
		// the root node might not exist.. eg if there are no records in the
		// table
		if (!this.RootNode)
		{
			return;
		}
		if (this.DEBUG_SAVE)
		{
			console.info('{cList:Attach}  Attaching the cList JS Object from the containing DIV  Name = ' + this.Name);
			console.info(this.RootNode);
		}
		this.RootNode.setAttribute('clistname', this.Name);
		this.ListName = this.Name;
		this.TableName = this.RootNode.getAttribute('TableName');
		this.DataViewName = this.RootNode.getAttribute('DataViewName');
		this.PluralRecordsLabel = this.RootNode.getAttribute('PluralRecordsLabel');
		this.SaveParms = this.RootNode.getAttribute('SaveParms');
		this.IsExpanded = true;
		this.ReadOnly = false;
		if ((this.RootNode.getAttribute('ReadOnly') == '1') || (this.RootNode.getAttribute('EffectiveAccessLevel') == 'Read') ||
			(this.RootNode.getAttribute('AccessLevel') == 'Read') || (this.RootNode.getAttribute('DataGroupAccessLevel') == 'Read'))
		{
			this.ReadOnly = true;
		}

		this.Page = this.RootNode.getAttribute('Page');
		this.RecordsPerPage = this.RootNode.getAttribute('RecordsPerPage');
		this.TotalCount = this.RootNode.getAttribute('TotalCount');
		this.EnableCountChange = this.RootNode.getAttribute('EnableCountChange');

		this.AllowEditFields = (this.RootNode.getAttribute('AllowEditFields') == 'true');
		this.EditURL = this.RootNode.getAttribute('EditURL');

		this.SortField = this.RootNode.getAttribute('SortField') ? this.RootNode.getAttribute('SortField').split(",") : new Array();
		this.SortOrder = this.RootNode.getAttribute('SortOrder') ? this.RootNode.getAttribute('SortOrder').split(",") : new Array();

		this.ChildTableName = this.RootNode.getAttribute('ChildTableName');

		this.Columns = this.RootNode.getAttribute('Columns') ? this.RootNode.getAttribute('Columns').split(',') : new Array();		

		var TaskParameters = this.RootNode.getAttribute('TaskParameters') ? this.RootNode.getAttribute('TaskParameters').split(',') : new Array();

		this.TaskParameters = new function()
		{
		}; // 'new function () {};'
		// produces essentially a
		// 'hash map' interface in
		// the form of an empty
		// object
		for ( var i = 0; i < TaskParameters.length; i++)
		{
			var Split = TaskParameters[i].indexOf('=');
			if (Split == -1)
			{
				continue;
			}

			this.TaskParameters[TaskParameters[i].substr(0, Split)] = TaskParameters[i].substr(Split + 1);
		}

		this.RefreshURL = this.RootNode.getAttribute('RefreshURL');

		this.BulkEnabled = this.RootNode.getAttribute('AllowBulkCommands') == 'true';
		this.AllowBulkSelect = this.RootNode.getAttribute('AllowBulkSelect') == 'true';
		// NoFloat this.FloatingHeadersEnabled =
		// this.RootNode.getAttribute('FloatingHeadersEnabled') == 'true';
		this.StretchWidth = this.RootNode.getAttribute('StretchWidth') == 'true';
		this.HasImages = this.RootNode.getAttribute('HasImages') == 'true';

		// NoFloat this.HeaderRows = new Array ();
		// NoFloat this.AnchorRows = new Array ();
		// NoFloat this.FloatingTables = new Array ();
		this.DataRows = new Array();
		this.ChildRows = new Array();

		this.BulkForm = FindElementWithClass(this.RootNode, 'BulkForm');

		this.SetListHeader();

		this.AutoViewCheckBox = null;
		var AutoViewCheckBoxes = document.getElementsByName('AutoViewNode');
		if (AutoViewCheckBoxes)
		{
			// jQuery duplicates the headers, the second one is displayed
			if (AutoViewCheckBoxes.length > 0)
			{
				this.AutoViewCheckBox = AutoViewCheckBoxes[AutoViewCheckBoxes.length - 1];
			}
		}

		this.ListTableDiv = FindElementWithClass(this.RootNode, 'ListTableDiv');
		if (this.ListTableDiv)
		{
			// must find all children of the this.ListTableDiv with the class
			// ListTable for the multicolumnlayout
			var selector = "#" + this.RootNode.id + " .ListTableDiv .ListTable";
			var ListTables = $(selector);

			if (ListTables)
			{
				for ( var i = 0; i < ListTables.length; i++)
				{
					this.ListTable = ListTables[i];

					if ('ul' === this.ListTable.tagName.toLowerCase())
					{
						var numListItems = this.ListTable.childNodes.length;
						for ( var k = 0; k < numListItems; k++)
						{
							var Row = this.ListTable.childNodes[k];
							this.DataRows.push(Row);
						}
					}
					else if ('table' === this.ListTable.tagName.toLowerCase())
					{
						for ( var k = 0; k < this.ListTable.rows.length; k++)
						{
							var Row = this.ListTable.rows[k];
							if (hasClass(Row, 'HeaderRow'))
							{
								// Note: jQuery duplicates the headers, the
								// second one is displayed
								this.HeaderRow = Row;
							}
							else if (hasClass(Row, 'DataRow'))
							{
								this.DataRows.push(Row);
							}
							else if (hasClass(Row, 'summary-row'))
							{
								this.DataRows.push(Row);
							}
							/**
							else
							{
								this.ChildRows.push(Row);
							}
							**/
						}
					}
				}
			}
		}

		var SelectTBody = FindElementWithClass(this.RootNode, 'SelectClass');
		if (SelectTBody)
		{
			// jQuery duplicates the headers, the second one is displayed
			var LastChild = SelectTBody.children.length - 1;
			this.HiddenSelectRow = SelectTBody.children[LastChild];
			this.HiddenSelectCheckbox = FindElementWithClass(this.HiddenSelectRow, 'HiddenSelectCheckBox');
			this.HiddenSelectCount = FindElementWithClass(this.HiddenSelectRow, 'HiddenSelectCount');
		}

		this.SetListFooter();
		this.ErrorBox = FindElementWithClass(this.ListFooter, 'ErrorBox');
		this.RecordCounter = FindElementWithClass(this.ListFooter, 'RecordCounter');

		this.AdjustHeaders();

		this.ResetIds();
	};

	// cList
	this.ClearForm = function()
	{
		while (true)
		{
			if ((this.BulkForm == undefined) || (this.BulkForm.length == undefined) || (this.BulkForm.length == 0))
			{
				break;
			}
			var LastChild = this.BulkForm.children[this.BulkForm.length - 1];
			this.BulkForm.removeChild(LastChild);
		}
	};

	// cList
	this.SetListHeader = function()
	{
		this.HasPaginator = false;
		this.BulkTasks = new Array();

		this.ListHeader = FindElementWithClass(this.RootNode, 'ListHeader');
		if (this.ListHeader)
		{
			var Row = this.ListHeader.rows[0];
			for ( var i = 0; i < Row.children.length; i++)
			{
				var HeaderCell = Row.children[i];
				if (HeaderCell.className == 'BulkTasks')
				{
					var List = this;
					var Cell = Row.children[0]; // TD of bulk tasks (and separators)
					$(Cell).find('a.BulkTaskLink').each(function()
					{
						List.BulkTasks.push(this);
					});
				}
			}
		}
	};

	// cList
	this.SetListFooter = function()
	{
		this.ListFooter = FindElementWithClass(this.RootNode, 'ListFooter');

		var Paginator = FindElementWithClass(this.RootNode, 'Paginator');
		if (Paginator)
		{
			var numItems = Paginator.childNodes.length;
			for ( var k = 0; k < numItems; k++)
			{
				var PageChild = Paginator.childNodes[k];
				if (PageChild.name == 'PageNumber')
				{
					this.HasPaginator = true;
					this.Paginator = PageChild;
				}
				else if (PageChild.name == 'Previous')
				{
					this.PreviousLink = PageChild;
				}
				else if (PageChild.name == 'Next')
				{
					this.NextLink = PageChild;
				}
			}
		}
	};

	// cList
	this.Copy = function(SrcList, ParentNode)
	{
		if (SrcList)
		{
			var SrcRoot = SrcList.RootNode;
			var RootNode = CopyElement(SrcList.RootNode, this.Name);
			for ( var attName in SrcRoot.Attributes)
			{
				var attribute = SrcRoot.attributes[attName];
				RootNode.setAttribute(attName, attribute);
			}
			RootNode.id = this.Name;
			ParentNode.appendChild(RootNode);

			this.Attach();
		}
	};

	this.AdjustHeaders = function()
	{
		if ((isset(this.ListHeader) === false) || (isset(this.ListFooter) === false))
		{
			return;
		}

		if (this.TotalCount == 0)
		{
			this.ListHeader.style.display = 'none';
			for ( var i = 0; i < this.BulkTasks.length; i++)
			{
				var BulkTask = this.BulkTasks[i];
				var MinAccessLevelRequired = BulkTask.getAttribute('MinAccessLevelRequired');
				if (MinAccessLevelRequired == 'None')
				{
					// Display the bulk commands, at least one does not require
					// a row selection
					this.ListHeader.style.display = '';
					break;
				}
			}
			this.ListFooter.style.display = 'none';
		}
		else
		{
			this.ListHeader.style.display = '';
			this.ListFooter.style.display = '';
		}
	};

	// cList
	this.GetErrorBox = function()
	{
		return this.ErrorBox;
	};

	this.ResetIds = function()
	{
		// 'new function () {};' produces essentially an 'associative array' in
		// the form of an empty object
		this.SelectedIds = new function()
		{
		};
		this.SelectedImageIds = new function()
		{
		};
		this.HiddenIds = new function()
		{
		};
		this.HiddenImageIds = new function()
		{
		};
		this.SavedHiddenIds = new function()
		{
		};
		this.SavedHiddenImageIds = new function()
		{
		};

		this.UpdateBulkActions();
	};

	this.DisplayError = function(Msg)
	{
		var ErrorBox = this.ErrorBox;
		if (this.ErrorBox)
		{
			ErrorBox.innerHTML += Msg + '<br>';
		}
	};

	this.ToggleList = function(DoExpand)
	{
		var Name = this.Name;

		if (DoExpand)
		{
			ExpandSection('Img' + Name, Name, Name);
			this.IsExpanded = true;
		}
		else
		{
			this.IsExpanded = ToggleSection('Img' + Name, Name, Name);
			if (this.IsExpanded == false)
			{
				return;
			}
		}

		this.Refresh(false);
	};

	// Return the number of elements in the associative array
	this.Count = function(obj)
	{
		var NumElements = 0;
		for (i in obj)
			NumElements++;
		return NumElements;
	};

	// Add selected parameters to page before navigation for bulk command
	// execution
	this.AddParams = function()
	{
		if (this.HasPaginator)
		{
			this.Paginator.disabled = true;
		}

		// Add appropriate ids for all rows checked on previous pages
		for ( var Id in this.HiddenIds)
			this.AddParam('Ids[]', Id);
		for ( var Id in this.HiddenImageIds)
			this.AddParam('ImageIds[]', Id);

		// Add appropriate ids from this page
		for ( var Id in this.SelectedIds)
			this.AddParam('Ids[]', Id);
		for ( var Id in this.SelectedImageIds)
			this.AddParam('ImageIds[]', Id);

		for ( var i in this.TaskParameters)
			this.AddParam(i, this.TaskParameters[i]);
	};

	this.AddParam = function(Name, Value)
	{
		if (this.BulkForm != undefined && this.BulkForm.length != undefined)
		{
			// first, see if a hidden input already exists in this.BulkForm
			var found = false;
			for ( var i = 0; i < this.BulkForm.length; i++)
			{
				var Child = this.BulkForm.children[i];
				if (Child.getAttribute('value') === Value && Child.getAttribute('name') === Name && Child.getAttribute('type') === 'hidden')
				{
					found = true;
					break;
				}
			}
			// if it is not already in this.BulkForm, add it
			if (false === found)
			{
				var input = document.createElement('INPUT');
				input.type = 'hidden';
				input.name = Name;
				input.value = Value;

				this.BulkForm.appendChild(input);
			}
		}
	};

	// Execute the chosen bulk task
	this.BulkAction = function(Link)
	{
		var Message = Link.getAttribute('Message');

		// If there's a select node (Dropdown) for this task, then
		// show it. Otherwise submit form.
		var SelectNode = (Link.nextElementSibling ? Link.nextElementSibling : false);

		if (SelectNode && (SelectNode.tagName == 'DIV'))
		{
			// make visible
			SelectNode.style.display = 'inline';
		}
		else
		{
			if ((Message != '') && (Message != null))
			{
				if (confirm(Message) == false)
				{
					return;
				}
			}

			this.ClearForm();
			this.AddParams();

			var Action = Link.getAttribute('FormAction');
			this.ExecuteBulkAction(Action);
		}
	};

	// Execute the chosen bulk task (with dropdown)
	this.BulkActionOption = function(Select)
	{
		// get the bulk task link for this <select>
		//		<div>
		//			<a>Generate Report</a>
		//			<textnode> </textnode>
		//			<div style="display:none; margin:0; padding:0">
		//				<select></select>
		//			</div>
		//		</div>
		// parentNode is the inner <div>
		// previousSibling is <textnode>
		// previousSibling.previousSibling is <a>
		var Link = Select.parentNode.previousSibling.previousSibling;

		// get the confirm message if there is one
		var Message = Select.getAttribute('Message');

		// if there's a confirm message specified then only act if user confirms
		if ((Message == '') || confirm(Message))
		{
			this.AddParams();

			var SelectedOption = Select.options[Select.selectedIndex];

			var Action = SelectedOption.getAttribute('action');
			if ((Action == null) || (Action == ''))
			{
				if (Link.getAttribute('formaction') != '')
				{
					Action = Link.getAttribute('formaction');
				}
				else
				{
					Action = this.BulkForm.action;
				}
			}

			// if the "select" has a name and the "option" has a value,
			// then append them to the form action.
			if ((Select.name != '') && (SelectedOption.value != ''))
			{
				if (Action.indexOf('?') < 0)
				{
					Action += "?" + Select.name + "=" + SelectedOption.value;
				}
				else
				{
					Action += "&" + Select.name + "=" + SelectedOption.value;
				}
			}

			this.ExecuteBulkAction(Action);
		}

		// reset the select div
		Select.selectedIndex = 0;
		Select.options[0].selected = true;
	};

	this.ExecuteBulkAction = function(Action)
	{
		if (Action.substr(0, 12) == 'javascript: ')
		{
			var Func = Action.substr(12);
			if (Func.indexOf('$form') > 0)
			{
				Func = Func.replace('$form', this.Name + '.BulkForm');
			}
			eval(Func);
		}
		else
		{
			if (Action != '')
			{
				this.BulkForm.action = Action;
			}

			this.BulkForm.submit();
			this.ClearForm();
			this.EnableControls();
		}
	};

	this.SubmitNode = function(URL)
	{
		SetupNodes(URL, this.Name);
		OperationQueue.Add('SubmitNodes');
		OperationQueue.Run();
	};

	// Called from Operation queue
	this.DoSubmit = function(URL)
	{
		var TheList = this;
		var Receiver = new function()
		{
			this.Receive = function(http_request)
			{
				if ((http_request.readyState == 4) && (http_request.status == 200))
				{
					PendingOperationRequests--;

					try
					{
						var Incoming = eval('(' + http_request.responseText + ')');
						CheckOperationStatus(TheList, Incoming);
						if (OperationErrorCode == 0)
						{
							TheList.ResetIds();
						}
						PageRedirect(TheList, Incoming);
					}
					catch (e)
					{
						DisplayJsonError(e, http_request);
					}
				}
			};
		};

		// Get needed parameters from the form
		var ParmArray = GetInputsForSubmit(this, this.BulkForm);
		var Parms = ParmArray.join('&');

		PendingOperationRequests++;
		HTTPRequest(URL, 'POST', Parms, Receiver);
	};

	this.GoToPage = function(Offset)
	{
		var Page;
		if (Offset == '+')
		{
			Page = parseInt(this.Page) + 1;
		}
		else if (Offset == '-')
		{
			Page = parseInt(this.Page) - 1;
		}
		else
		{
			Page = parseInt(Offset);
		}

		var MaxPages = Math.ceil(parseInt(this.TotalCount) / parseInt(this.RecordsPerPage));

		Page = ForceToNumber(Page, 1, MaxPages, 1);

		this.Page = Page;
		this.Refresh(true);
	};

	this.Sort = function(Element, CtrlKeyPressed)
	{
		var sortField = Element.getAttribute('Key');
		var sortOrder = Element.getAttribute('NewOrder');

		if (this.CTRL_KEY_MULTICOLUMN_ENABLED)
		{
			if (CtrlKeyPressed)
			{
				// if the inbound sortField is already in the sort then toggle
				// the order without changing rank
				var sortIndex = $.inArray(sortField, this.SortField);
				if (-1 !== sortIndex)
				{
					this.SortOrder[sortIndex] = sortOrder;
				}
				else
				{
					// inbound columns are single valued so they don't need a
					// split of columns
					this.SortField[this.SortField.length] = sortField;
					this.SortOrder[this.SortOrder.length] = sortOrder;
				}
			}
			else
			{
				// inbound columns are single valued so they don't need a split
				// of columns
				this.SortField = Array(sortField);
				this.SortOrder = Array(sortOrder);
			}
		}
		else
		{
			// TODO: RK_UPDATE_FOR_SIDE_BY_SIDE_SEARCH

			// inbound columns are single valued so they don't need a split of
			// columns
			this.SortField = Array(sortField);
			this.SortOrder = Array(sortOrder);
		}
		this.Refresh(true);
	};

	// User clicked on Select All box in header
	this.BulkCheck = function(Element)
	{
		var IsChecked = Element.checked;

		if (Element.disabled)
		{
			Element.disabled = false;
		}

		for ( var row = 0; row < this.DataRows.length; row++)
		{
			var Row = this.DataRows[row];
			var CheckBox = this.GetCheckBox(Row, 'Ids[]');
			if (CheckBox)
			{
				CheckBox.checked = IsChecked;

				// call OnCheck to set autoselect cookies if enabled
				this.SelectRow(CheckBox);
			}
		}

		this.UpdateBulkActions();

		this.UpdateBulkCheck(IsChecked);
	};

	// Update the bulk check box
	this.UpdateBulkCheck = function(IsChecked)
	{
		var CheckBox = this.GetCheckBox(this.HeaderRow, 'BulkSelectBox');
		if (CheckBox)
		{
			CheckBox.checked = IsChecked;
		}
	};

	// User clicked on a row's checkbox
	this.OnCheck = function(CheckBox)
	{
		this.SelectRow(CheckBox);

		this.UpdateBulkActions();

		this.DetermineBulkCheck();
	};

	// cList
	this.SelectRow = function(CheckBox)
	{
		// If this list supports AutoSelect, save cookie accordingly
		var AutoSelectCookieName = CheckBox.getAttribute('autoselectcookiename');
		if (AutoSelectCookieName != null)
		{
			SetCookie(AutoSelectCookieName, (CheckBox.checked ? 1 : 0), 5);
		}

		var Row = FindParentWithTag(CheckBox, 'tr');
		var Id = Row.getAttribute('Ids');
		var ImageId = Row.getAttribute('ImageIds');

		if (CheckBox.checked)
		{
			var EffectiveAccessLevel = GetLowestAccessLevel(Row.getAttribute('EffectiveAccessLevel'), Row.getAttribute('DataGroupAccessLevel'));
			this.SelectedIds[Id] = EffectiveAccessLevel;
			if (ImageId > 0)
			{
				this.SelectedImageIds[ImageId] = EffectiveAccessLevel;
			}
		}
		else
		{
			delete this.SelectedIds[Id];
			if (ImageId > 0)
			{
				delete this.SelectedImageIds[ImageId];
			}
			// remove it from the hidden inputs
			for ( var i = this.BulkForm.length - 1; i > -1; i--)
			{
				var Child = this.BulkForm.children[i];
				if (Child.getAttribute('type') === 'hidden' && Child.getAttribute('name') === 'Ids[]' && Child.getAttribute('value') === Id)
				{
					this.BulkForm.removeChild(Child);
				}
			}
		}
	};

	// Enable/Disable all bulk commands based upon records selected
	this.UpdateBulkActions = function()
	{
		if (!this.BulkEnabled)
		{
			return;
		}

		// Determine the lowest access levels amongst the checked rows
		var AccessLevel = 'Default';
		var ImageAccessLevel = 'Default';

		for ( var id in this.SelectedIds)
		{
			var RowAccessLevel = this.SelectedIds[id];
			AccessLevel = GetLowestAccessLevel(AccessLevel, RowAccessLevel);
			if (AccessLevel == 'Read')
			{
				break;
			}
		}
		for ( var id in this.SelectedImageIds)
		{
			var RowAccessLevel = this.SelectedImageIds[id];
			ImageAccessLevel = GetLowestAccessLevel(ImageAccessLevel, RowAccessLevel);
			if (ImageAccessLevel == 'Read')
			{
				break;
			}
		}

		for ( var id in this.HiddenIds)
		{
			var RowAccessLevel = this.HiddenIds[id];
			AccessLevel = GetLowestAccessLevel(AccessLevel, RowAccessLevel);
			if (AccessLevel == 'Read')
			{
				break;
			}
		}
		for ( var id in this.HiddenImageIds)
		{
			var RowAccessLevel = this.HiddenImageIds[id];
			ImageAccessLevel = GetLowestAccessLevel(ImageAccessLevel, RowAccessLevel);
			if (ImageAccessLevel == 'Read')
			{
				break;
			}
		}

		if (AccessLevel == 'Default')
		{
			AccessLevel = 'None'; // No rows
			// were
			// selected
		}
		if (ImageAccessLevel == 'Default')
		{
			ImageAccessLevel = 'None'; // No
			// rows
			// with
			// images
			// were
			// selected
		}

		// Update the bulk tasks according to the access levels
		for ( var i = 0; i < this.BulkTasks.length; i++)
		{
			var BulkTask = this.BulkTasks[i];
			removeClass(BulkTask, 'Disabled');

			if (BulkTask.getAttribute('SelectOne') == 'true')
			{
				if (this.GetSelectCount() != 1)
				{
					DisableBulk(BulkTask);
					continue;
				}
			}

			var MinAccessLevelRequired = BulkTask.getAttribute('MinAccessLevelRequired');
			var TaskAccessLevel = 'Default';
			var IdField = this.BulkTasks[i].getAttribute('IdFields');
			if (IdField != '')
			{
				IdFields = IdField.split(',');
				if (IdFields.length > 1)
				{
					// Multiple Id fields required (allow command if any access
					// level meets the minimum)
					// the access level for 'Id' is always there and is the
					// lowest
					TaskAccessLevel = AccessLevel;
				}
				else if (IdField == 'Ids')
				{
					TaskAccessLevel = AccessLevel;
				}
				else if (IdField == 'ImageIds')
				{
					TaskAccessLevel = ImageAccessLevel;
				}
			}
			if (GetLowestAccessLevel(TaskAccessLevel, MinAccessLevelRequired) == MinAccessLevelRequired)
			{
				EnableBulk(BulkTask);
			}
			else
			{
				DisableBulk(BulkTask);
			}
		}
	};

	this.DetermineBulkCheck = function(IsChecked)
	{
		if (this.DataRows.length == 0)
		{
			return;
		}

		for ( var row = 0; row < this.DataRows.length; row++)
		{
			var Row = this.DataRows[row];
			var CheckBox = this.GetCheckBox(Row, 'Ids[]');
			if (CheckBox)
			{
				if (CheckBox.checked == false)
				{
					this.UpdateBulkCheck(false);
					return;
				}
			}
		}

		this.UpdateBulkCheck(true);
	};

	// User clicked on 'hidden' checkbox (items selected on other pages)
	this.OnHidden = function(CheckBox)
	{
		if (CheckBox.checked)
		{
			this.HiddenIds = this.SavedHiddenIds;
			this.HiddenImageIds = this.SavedHiddenImageIds;
		}
		else
		{
			this.SavedHiddenIds = this.HiddenIds;
			this.SavedHiddenImageIds = this.HiddenImageIds;
			this.HiddenIds = new function()
			{
			};
			this.HiddenImageIds = new function()
			{
			};
		}
	};

	// Return the requested checkbox for 'Row'
	this.GetCheckBox = function(Row, Name)
	{
		if (undefined == Row)
		{
			return;
		}

		var Inputs = Row.getElementsByTagName('Input');
		for ( var i = 0; i < Inputs.length; i++)
		{
			if (Inputs[i].name == Name)
			{
				return Inputs[i];
			}
		}
		return null;
	};

	this.GetIds = function(Row, Col, Operation)
	{
		var Ids = "";
		if ("Save" === Operation)
		{
			var mostSpecificId = undefined;
			// most to least specific assigment of the primarykey ids
			// the column always has a more specific identifier than the row
			var pk_col_attr = Col.getAttribute('PrimaryKey');
			mostSpecificId = (undefined == mostSpecificId ? pk_col_attr : mostSpecificId);
			var ids_col_attr = Col.getAttribute('Ids');
			mostSpecificId = (undefined == mostSpecificId ? ids_col_attr : mostSpecificId);
			var pk_row_attr = Row.getAttribute('PrimaryKey');
			mostSpecificId = (undefined == mostSpecificId ? pk_row_attr : mostSpecificId);
			var ids_row_attr = Row.getAttribute('Ids');
			mostSpecificId = (undefined == mostSpecificId ? ids_row_attr : mostSpecificId);

			Ids = 'Ids[]=' + mostSpecificId;
			if (Row.getAttribute('ImageIds'))
			{
				Ids += '&ImageIds[]=' + Row.getAttribute('ImageIds');
			}
		}
		else if ("Update" === Operation)
		{
			var mostSpecificId = undefined;
			// most to least specific assigment of the primarykey ids
			// When updating cRecord() PHP needs the "TopMost" Row identifier to
			// fetch the entire record
			// EX: If the view has CaseDownToSpecimen.Id and you are updating
			// The Specimen.AccessionNumber
			// then the Case Id has to be sent as the Id
			var pk_col_attr = Col.getAttribute('PrimaryKey');
			mostSpecificId = (undefined == mostSpecificId ? pk_col_attr : mostSpecificId);
			var ids_col_attr = Col.getAttribute('Ids');
			mostSpecificId = (undefined == mostSpecificId ? ids_col_attr : mostSpecificId);
			var pk_row_attr = Row.getAttribute('PrimaryKey');
			mostSpecificId = (undefined == mostSpecificId ? pk_row_attr : mostSpecificId);
			var ids_row_attr = Row.getAttribute('Ids');
			mostSpecificId = (undefined == mostSpecificId ? ids_row_attr : mostSpecificId);

			Ids = 'Ids[]=' + mostSpecificId;
			if (Row.getAttribute('ImageIds'))
			{
				Ids += '&ImageIds[]=' + Row.getAttribute('ImageIds');
			}
		}
		return Ids;
	};

	this.SaveNode = function()
	{
		// Do both a save and update in one step
		SetupNodes('Save', this.Name);
		OperationQueue.Add('SaveNodes');
		OperationQueue.Add('UpdateNodes');
		if (RefreshAfterSave)
		{
			OperationQueue.Add('RefreshNodes');
		}
		if (RefreshGridsAfterSave)
		{
			OperationQueue.Add('RefreshGrids');
		}
		OperationQueue.Run();
	};

	this.DoSave = function()
	{
		this.UpdateRecords('Save');
	};

	// Note: since changes may ripple across rows (eg. DataGroup changes in a
	// parent also change its children),
	// we now update all rows after a SaveData()
	this.DoUpdate = function()
	{
		this.UpdateRecords('Update');
	};

	// Called from RefreshNodes()
	this.DoRefresh = function()
	{
		this.Refresh(false);
	};

	this.GetRowInput = function(Row, RowIndex)
	{
		if ('li' === Row.tagName.toLowerCase())
		{
			return Row.childNodes[RowIndex];
		}
		else if ('tr' === Row.tagName.toLowerCase())
		{
			return Row.cells[RowIndex];
		}
		return undefined;
	};

	this.HasDataRows = function()
	{
		if (undefined === this.DataRows)
		{
			// if the page hasn't loaded the nodes [ajax] force the nodes to
			// resync
			this.Attach();
			if (undefined === this.DataRows)
			{
				// nothing can be done when the cList has no records
				return false;
			}
		}
		return true;
	};

	this.UpdateRecords = function(Operation)
	{
		var ErrorBox = this.GetErrorBox();
		if (ErrorBox)
		{
			ErrorBox.innerHTML = '';
		}

		if (!this.HasDataRows())
		{
			return;
		}

		// the same request may be found multiple times if for the same sql
		// table
		// keep track of which URL was already requested, and only ask for the
		// update once
		var ParmArrayUnJoined = new Array();

		for ( var rowIdx = 0; rowIdx < this.DataRows.length; rowIdx++)
		{
			var Row = this.DataRows[rowIdx];
			// iterate through columns
			for ( var j = 0, Col; Col = this.GetRowInput(Row, j); j++)
			{
				var isTextOnly = (document.TEXT_NODE === Col.nodeType);
				var isLabel = ((document.ELEMENT_NODE === Col.nodeType) && ('label' === Col.tagName.toLowerCase()));
				var isExtraInfo = ((document.ELEMENT_NODE === Col.nodeType) && ('ExtraReadOnlyInfo' === Col.getAttribute('Class')));
				var canSkipElement = isTextOnly || isLabel || isExtraInfo;
				if (canSkipElement)
				{
					continue;
				}
				var ParmArrayRow = {};
				// GENERAL Op Queue Paramters to Record_Save
				if (this.DataViewName)
				{
					ParmArrayRow[this.InputParametersEnumeration.DATAVIEW_NAME] = 'DataViewName=' + this.DataViewName;
				}
				ParmArrayRow[this.InputParametersEnumeration.LIST_NAME] = 'ListName=' + this.ListName;
				var operationIds = this.GetIds(Row, Col, Operation);
				if ('Ids[]=' !== operationIds)
				{
					ParmArrayRow[this.InputParametersEnumeration.PRIMARY_KEYS] = operationIds;
				}
				else
				{
					// if the ids array is set to zero PutRecordData() attempts
					// to add a record
					ParmArrayRow[this.InputParametersEnumeration.PRIMARY_KEYS] = 'Ids[]=0';
				}
				ParmArrayRow[this.InputParametersEnumeration.DATA_ROW_INDEX] = rowIdx;
				// END GENERAL Op Queue Paramters

				if (Operation == 'Save')
				{
					var inputsForSave = GetInputsForSave(this, Col);
					if (0 == inputsForSave.length)
					{
						continue;
					}
					if (this.DEBUG_SAVE)
					{
						console.info('{cList:UpdateRecords}  GetInputsForSave ');
						console.info(inputsForSave);
					}
					ParmArrayRow[this.InputParametersEnumeration.HTML_INPUTS] = inputsForSave;
					ParmArrayRow[this.InputParametersEnumeration.UPDATE_OR_SAVE] = this.UpdateSaveEnumeration.SAVE;

					for ( var sidx = 0; sidx < inputsForSave.length; sidx++)
					{
						var inputVal = inputsForSave[sidx];
						if (((inputVal.indexOf("DoSave=") >= 0) || (inputVal.indexOf("Pass=") >= 0)) && (inputVal.indexOf("SigPassword=") < 0))
						{
							ParmArrayRow[this.InputParametersEnumeration.DO_SAVE_PASS] = inputVal;
						}
						else if (inputVal.indexOf("NodeName=") >= 0)
						{
							ParmArrayRow[this.InputParametersEnumeration.NODE_NAME] = inputVal;
						}
						else if (inputVal.indexOf("ReadOnly=") >= 0)
						{
							ParmArrayRow[this.InputParametersEnumeration.READ_ONLY] = inputVal;
						}
						else if (inputVal.indexOf("TableName=") >= 0)
						{
							ParmArrayRow[this.InputParametersEnumeration.TABLE_NAME] = inputVal;
						}
						else if ((inputVal.indexOf("RfcValue=") >= 0) || (inputVal.indexOf("RfcComment=") >= 0))
						{
							ParmArrayRow[this.InputParametersEnumeration.RFC] = inputVal;
						}
						else if ((inputVal.indexOf("SigUserName=") >= 0) || (inputVal.indexOf("SigPassword=") >= 0))
						{
							ParmArrayRow[this.InputParametersEnumeration.ESIG] = inputVal;
						}
						else
						{
							if (ParmArrayRow[this.InputParametersEnumeration.SQL_COLUMN] == undefined)
								ParmArrayRow[this.InputParametersEnumeration.SQL_COLUMN] = inputVal;
							else
								ParmArrayRow[this.InputParametersEnumeration.SQL_COLUMN] += '&' + inputVal;
						}
					}

					if ((ParmArrayRow.length == 0) && (DoForceSave == false))
					{
						continue;
					}
					if (this.SaveParms)
					{
						ParmArrayRow[this.InputParametersEnumeration.SAVE_PARMS] = this.SaveParms;
					}
				}
				else
				// if (Operation == 'Update')
				{
					var inputsForUpdate = GetInputsForUpdate(this, Col);
					if (this.DEBUG_SAVE)
					{
						console.info('{cList:UpdateRecords}  GetInputsForUpdate ');
						console.info(inputsForUpdate);
					}
					ParmArrayRow[this.InputParametersEnumeration.HTML_INPUTS] = inputsForUpdate;
					ParmArrayRow[this.InputParametersEnumeration.UPDATE_OR_SAVE] = this.UpdateSaveEnumeration.UPDATE;

					for ( var uidx = 0; uidx < inputsForUpdate.length; uidx++)
					{
						var updateVal = inputsForUpdate[uidx];

						if ((updateVal.indexOf("UpdateOnly") >= 0) || (updateVal.indexOf("Pass") >= 0))
						{
							ParmArrayRow[this.InputParametersEnumeration.DO_SAVE_PASS] = updateVal;
						}
						else if (updateVal.indexOf("NodeName") >= 0)
						{
							ParmArrayRow[this.InputParametersEnumeration.NODE_NAME] = updateVal;
						}
						else if (updateVal.indexOf("TableName") >= 0)
						{
							ParmArrayRow[this.InputParametersEnumeration.TABLE_NAME] = updateVal;
						}
					}
				}
				ParmArrayUnJoined[ParmArrayUnJoined.length] = ParmArrayRow;
			}
		}
		var unJoinedToDelete = new Array();
		for ( var unJoinedIndex = 0; unJoinedIndex < ParmArrayUnJoined.length; unJoinedIndex++)
		{
			// no html inputs were found for this cell
			if (0 === ParmArrayUnJoined[unJoinedIndex][this.InputParametersEnumeration.HTML_INPUTS].length)
			{
				unJoinedToDelete[unJoinedToDelete.length] = unJoinedIndex;
			}
		}
		// remove all the paramaters that are not being processed for save or
		// update
		for ( var unJoinedDeleteIndex = 0; unJoinedDeleteIndex < unJoinedToDelete.length; unJoinedDeleteIndex++)
		{
			delete ParmArrayUnJoined[unJoinedToDelete[unJoinedDeleteIndex]];
		}
		ParmArrayUnJoined = RemoveUndefinedArrayElements(ParmArrayUnJoined);

		// need to loop over all of the rows in ParmArrayUnJoined and determine
		// if they need saving or updating
		var done = (ParmArrayUnJoined.length === 0);
		var outerIndex = 0;
		while (!done)
		{
			var outerValue = ParmArrayUnJoined[outerIndex];
			var unJoinedOuterToDelete = new Array();
			for ( var innerIndex = outerIndex + 1; innerIndex < ParmArrayUnJoined.length; innerIndex++)
			{
				var innerValue = ParmArrayUnJoined[innerIndex];
				if ((outerValue[this.InputParametersEnumeration.SAVE_PARMS] === innerValue[this.InputParametersEnumeration.SAVE_PARMS]) && (outerValue[this.InputParametersEnumeration.TABLE_NAME] === innerValue[this.InputParametersEnumeration.TABLE_NAME]) && (outerValue[this.InputParametersEnumeration.LIST_NAME] === innerValue[this.InputParametersEnumeration.LIST_NAME]) && (outerValue[this.InputParametersEnumeration.PRIMARY_KEYS] === innerValue[this.InputParametersEnumeration.PRIMARY_KEYS])
						&& (outerValue[this.InputParametersEnumeration.NODE_NAME] === innerValue[this.InputParametersEnumeration.NODE_NAME]))
				{
					// the value is from the same sql table and row
					if (isset(ParmArrayUnJoined[innerIndex][this.InputParametersEnumeration.SQL_COLUMN]))
					{
						ParmArrayUnJoined[outerIndex][this.InputParametersEnumeration.SQL_COLUMN] += "&" + ParmArrayUnJoined[innerIndex][this.InputParametersEnumeration.SQL_COLUMN];
						unJoinedOuterToDelete[unJoinedOuterToDelete.length] = innerIndex;
					}
				}
			}
			// remove all the inputs that have been combined
			for ( var unJoinedOuterDeleteIndex = 0; unJoinedOuterDeleteIndex < unJoinedOuterToDelete.length; unJoinedOuterDeleteIndex++)
			{
				delete ParmArrayUnJoined[unJoinedOuterToDelete[unJoinedOuterDeleteIndex]];
			}
			ParmArrayUnJoined = RemoveUndefinedArrayElements(ParmArrayUnJoined);

			outerIndex++;
			done = (outerIndex <= ParmArrayUnJoined.length);
			done = true;
		}

		var ParmArrayUnSent = {};
		var ParmArrayUnSentRow = {};
		for ( var sendIndex = 0; sendIndex < ParmArrayUnJoined.length; sendIndex++)
		{
			var sendValue = ParmArrayUnJoined[sendIndex];
			var sendRow = ParmArrayUnJoined[sendIndex][this.InputParametersEnumeration.DATA_ROW_INDEX];
			var unSentParm = {};
			if (this.UpdateSaveEnumeration.SAVE === sendValue[this.InputParametersEnumeration.UPDATE_OR_SAVE])
			{
				unSentParm = sendValue[this.InputParametersEnumeration.DO_SAVE_PASS] + "&" + (sendValue[this.InputParametersEnumeration.SAVE_PARMS] ? sendValue[this.InputParametersEnumeration.SAVE_PARMS] + "&" : "") + sendValue[this.InputParametersEnumeration.TABLE_NAME] + "&" + (sendValue[this.InputParametersEnumeration.DATAVIEW_NAME] ? sendValue[this.InputParametersEnumeration.DATAVIEW_NAME] + "&" : "") + sendValue[this.InputParametersEnumeration.LIST_NAME] + "&"
						+ sendValue[this.InputParametersEnumeration.NODE_NAME] + "&" + (sendValue[this.InputParametersEnumeration.READ_ONLY] ? sendValue[this.InputParametersEnumeration.READ_ONLY] + "&" : "") + sendValue[this.InputParametersEnumeration.SQL_COLUMN] + "&" + (sendValue[this.InputParametersEnumeration.RFC] ? sendValue[this.InputParametersEnumeration.RFC] + "&" : "") + (sendValue[this.InputParametersEnumeration.ESIG] ? sendValue[this.InputParametersEnumeration.ESIG] + "&" : "")
						+ sendValue[this.InputParametersEnumeration.PRIMARY_KEYS];
			}
			else if (this.UpdateSaveEnumeration.UPDATE === sendValue[this.InputParametersEnumeration.UPDATE_OR_SAVE])
			{
				unSentParm = sendValue[this.InputParametersEnumeration.DO_SAVE_PASS] + "&" + sendValue[this.InputParametersEnumeration.TABLE_NAME] + "&" + (sendValue[this.InputParametersEnumeration.DATAVIEW_NAME] ? sendValue[this.InputParametersEnumeration.DATAVIEW_NAME] + "&" : "") + sendValue[this.InputParametersEnumeration.NODE_NAME] + "&" + (sendValue[this.InputParametersEnumeration.RFC] ? sendValue[this.InputParametersEnumeration.RFC] + "&" : "")
						+ (sendValue[this.InputParametersEnumeration.ESIG] ? sendValue[this.InputParametersEnumeration.ESIG] + "&" : "") + sendValue[this.InputParametersEnumeration.PRIMARY_KEYS];
			}
			// remove any of the Update Operations that are duplicates
			if (!(unSentParm in ParmArrayUnSent))
			{
				ParmArrayUnSent[unSentParm] = unSentParm;
				ParmArrayUnSentRow[unSentParm] = sendRow;
			}
		}

		// In Spectrum+ The slide table contains the Image Records
		// However, GetTableObj(Image) is incorrect in Record_Save.php
		// In SHC a mixed, slide/image view might exist and because the DataView
		// name
		// is passed in the URL and the Slide/Image confusion does not affect
		// the update loop
		// Also remove any update requests that contain &undefined& which
		// implies that the sql column for the specified text node was not found
		var duplicateImageUrl = {};
		for ( var parmsUrlSlide in ParmArrayUnSent)
		{
			for ( var parmsUrlImage in ParmArrayUnSent)
			{
				if (ParmArrayUnSent[parmsUrlSlide] === ParmArrayUnSent[parmsUrlImage])
				{
					continue;
				}
				// IF there are EXACTLY duplicate URLS except for the difference
				// of TableName Slide/Image then
				// in SP+ the Image Request cannot happen because of the Slide
				// table contains the Image Records
				var urlSlideReplace = ParmArrayUnSent[parmsUrlImage].replace('TableName=Slide', 'TableName=Image');
				if (ParmArrayUnSent[parmsUrlSlide] === urlSlideReplace)
				{
					duplicateImageUrl[parmsUrlSlide] = parmsUrlSlide;
				}
				var undefinedUpdate = ParmArrayUnSent[parmsUrlSlide];
				if (-1 != undefinedUpdate.indexOf("&undefined&"))
				{
					duplicateImageUrl[parmsUrlSlide] = parmsUrlSlide;
				}
			}
		}
		// remove the duplicate image update requests
		for ( var removeImageUrl in duplicateImageUrl)
		{
			delete ParmArrayUnSent[removeImageUrl];
		}

		for ( var Parms in ParmArrayUnSent)
		{
			var TheList = this;
			var Receiver = new function()
			{
				this.RowIdx = ParmArrayUnSentRow[Parms];

				this.Receive = function(http_request)
				{
					if ((http_request.readyState == 4) && (http_request.status == 200))
					{
						PendingOperationRequests--;

						try
						{
							var Incoming = eval('(' + http_request.responseText + ')');
							TheList.ProcessRecordSavePhpResponse(Incoming, this.RowIdx);
							PageRedirect(TheList, Incoming);
						}
						catch (e)
						{
							DisplayJsonError(e, http_request);
						}
					}
				};
			};
			if (this.DEBUG_SAVE)
			{
				console.info('{cList:UpdateRecords}  HTTPRequest ' + this.EditURL + '?' + Parms);
			}
			HTTPRequest(this.EditURL, 'POST', Parms, Receiver);
			PendingOperationRequests++;
		}
	};

	this.CopyInputParameters = function(Cell, htmlInputAsString)
	{
		var htmlId = Cell.id;
		var ColumnName = Cell.getAttribute('ColumnName');
		var htmlInputAsString = $.trim(htmlInputAsString);

		// spectrum plus has some legacy code that needs the period character in
		// the id
		// this results from cField where id is generated from the
		// TableName.ColumnName
		var escapsedhtmlId = htmlId.replace(/\./g, '\\.');

		// copy the incoming attributes from cField::ToHTML() from
		// record_save.php
		// sets the incoming attributes onto the existing <input>
		// prevents the loss of any already bound events

		// do not set the id or type
		var attrsToCopy =
		{
			'PrimaryKey' : '',
			'TableName' : '',
			'ColumnName' : '',
			'ForeignKeyColumnName' : '',
			'ForeignKeyTableName' : ''
		};

		if (escapsedhtmlId)
		{
			// In Spectrum Plus and Healthcare only <td></td> with two or less
			// html inputs are supported
			// The only exception is SSP, where the score column can have a user
			// defined number of inputs
			// Spectrum Healthcare needs to maintain the bound() js functions
			// and styles on the html elements
			// and not blindly overwrite the current element with the return
			// from Record_Save.php
			var oldElement;
			var oldWrapper = $('#' + escapsedhtmlId + ':input');
			if (oldWrapper.length <= 0)
				oldWrapper = $('#' + escapsedhtmlId);
			if (oldWrapper.length > 0)
			{
				oldElement = oldWrapper[0];
			}
			else
			{
				// Try the old fashion way
				oldElement = document.getElementById(htmlId);
				if (oldElement == null)
				{
					alert('Invalid Record Update: No records found matching criteria');
					return;
				}
			}

			var tagName = $(oldElement).prop('tagName');
			if (tagName == 'TD')
			{
				var Atts = $(oldElement).getAttributes()
				if (Atts.allowoverwrite == '1')
				{
					// We are allowed to overwrite this control.
					$(oldElement).empty().append(htmlInputAsString);
					return;
				}

				// If there is a single control within the TD, then set oldElement to that control
				if (oldElement.children.length == 1)
					oldElement = oldElement.children[0];
			}

			var oldNumControls = $(oldElement).length;

			// as of jQuery 1.8.3, if you attempt to pass to the $() function a string that does not
			// start with a valid html tag such as <input>, and the string contains special characters
			// which are meaningful as CSS selectors (such as /, (), or []), an error is generated. 
			// an example is a date string such as '2013/09/30'
			//
			// this error occurs when the htmlInputAsString is from a text node. Since there are no <text> tags in a text node,
			// the string is misinterpreted by jQuery to be a malformed css selector, resulting in an error being thrown.
			// a workaround is to wrap the text string in a <span>
			if ($.trim(htmlInputAsString).substr(0, 1) != '<')
				var htmlInputAsObject = $('<span>' + htmlInputAsString + '</span>');
			else
				htmlInputAsObject = $(htmlInputAsString);
			var possibleNumNewElements = htmlInputAsObject;
			var newElementLength = $(possibleNumNewElements).find(':input').length + possibleNumNewElements.length;
			if ((1 === oldNumControls) && (1 === newElementLength))
			{
				// handle the simple case of 1 input inbound and 1 existing inside a container
				// all other containers are blindly replaced removing any attached events or styles
				// for ( var index = 0; index < oldNumControls; index++)	// there's only one control
				{
					var newElement = htmlInputAsObject;
					if (null === $(newElement).html())
					{
						// this is only a text node
						// EG. Not an anchor, or input, select etc. Just Straight
						// text
						$(oldElement).html(htmlInputAsString);
						return;
					}

					// copy the attributes
					var newAttributes = newElement.getAttributes();
					for (var attr in newAttributes)
					{
						var attr = attr.toLowerCase();	// Chrome keeps attributes in lower case and does a case sensitive search
						var attrVal = newAttributes[attr];
						if ($(oldElement).attr(attr) == attrVal)
							continue;

						if (attr === 'class')
						{
							// class is editRecord & Modfied
							$(oldElement).removeClass('Modified').addClass(attrVal);
						}
						else if (attr === 'value' || attr === 'oldvalue' || attr === 'sspconfig' || attr === 'getapproval')
						{
							$(oldElement).attr(attr, attrVal);
						}
						else if ((attr in attrsToCopy) && !$.isFunction(newAttributes[attr]))
						{
							// SELECT and their options are not updated from the
							// oqueue with new values
							// the do not have primary key information from the
							// master lookup tables
							// Also same issue is happening in IE8 for TD and TextArea
							if (('primaryKey' === attr) &&
										 (('SELECT' === oldElement.tagName)
										|| ('OPTION' === oldElement.tagName)
										|| ('TD' === oldElement.tagName)
										|| ('TEXTAREA' === oldElement.tagName))
							)
							{
								if (this.DEBUG_SAVE)
								{
									console.info('{cList:CopyInputParameters} SELECT and their OPTIONS. This fall through is okay in SP+');
								}
							}
							else
							{
								// If this alert happens it implies that
								// Record_Save.php has
								// emitted an html control that is attempting to
								// be updated in JS that doesn't match the
								// current control
								if ((0 !== $(oldElement).html().length) || (0 !== $(newElement).html().length))
								{
									alert('Invalid Record Update of HTML Control ' + htmlId);
									return;
								}
							}
						}
					}
				}
			}
			else
			{
				// Multiple controls
				// The SSP score <td> section of the Slides Details List
				// has a user configurable set of HTML inputs
				// copy the ENTIRE returning HTML from FieldUpdater.js and
				// Record_Save.php
				// IE8 in various modes will not update the contents of a td
				// with text nodes

				// The Combination Canned Comment Drop Down <select><option>
				// control set also falls through into this block
				// Any other non single control inside of a TD will fall through
				// and set whatever came out of cRecord
				// Any bound events will be lost, including css class etc

				// cRecord.PHP removes the TD before sending it back to the JS ~
				// line 430
				// All other browsers than IE8 behave as expected with
				// replaceWith but IE8 works better with the html function

				// set the element's closest <td>'s html
				// normally the closest <td> is the element itself. But, when a slide is changed from non-ssp to ssp,
				// the slide comment oldElement changes from a <textarea/> to a <select/><br/><textarea/> that needs
				// to be contained in the element's parent <td>
				$(oldElement).closest('td').html(htmlInputAsString);
			}
		}
	};

	// Receive message from Record_Save.php
	this.ProcessRecordSavePhpResponse = function(Incoming, RowIdx)
	{
		if (this.DEBUG_SAVE)
		{
			console.info('{cList:ProcessRecordSavePhpResponse}  ');
			console.info(Incoming);
		}

		if (!this.HasDataRows())
		{
			CheckOperationStatus(this, Incoming);
			return;
		}

		// Repsonse Looks Like [VIEWS]:
		// Cells:
		// 0: { 'DownToSpecimenByParentId.GrossDescription' :
		// {'Contents' : '<textarea> .... </textarea>',
		// 'PrimaryKey' : '1' ,
		// 'TableName' : 'AllRecords_xxx' }
		// Repsonse Looks Like [SpectrumPlus SingleTable]:
		// Cells:
		// { 'DownToSpecimenByParentId.GrossDescription' :
		// {'Contents' : '<textarea> .... </textarea>',
		// 'PrimaryKey' : '2' ,
		// 'TableName' : 'Case' }}}
		var rowsForUpdateCount = 0;
		for ( var returnedRowIndex in Incoming.Cells)
		{
			for ( var prop2 in Incoming.Cells[returnedRowIndex])
			{
				rowsForUpdateCount++;
				// more column than one is sufficient
				break;
			}
			if (0 > rowsForUpdateCount)
			{
				break;
			}
		}

		var dataRowLength = this.DataRows.length;
		if (!this.DataViewName)
		{
			// only walk the incoming row [RowIdx] if the current item is not a
			// DataView
			dataRowLength = 1;
		}

		// walk all of the rows in the current list object and update the
		// entries
		// cannot use just the RowIdx because when the list is a multicolumn
		// layout each cell
		// is a different entry in this.DataRows and only one response from
		// Record_Save.php exists
		// for each of the submitted save requests
		for ( var rowIndex = 0; rowIndex < dataRowLength; rowIndex++)
		{
			var Row;
			if (this.DataViewName)
			{
				// the Row is from a cViewSchema
				// each "Row" is really a table cell
				Row = this.DataRows[rowIndex];
			}
			else
			{
				// the Row is from the standard cList PHP object.
				// each Row in the html table is from only one entry in
				// this.DataRows
				Row = this.DataRows[RowIdx];
			}

			if (Incoming.Attributes != undefined)
			{
				for ( var attName in Incoming.Attributes)
				{
					if (attName == 'class')
					{
						Row.className = Incoming.Attributes[attName];
					}
					else
					{
						Row.setAttribute(attName, Incoming.Attributes[attName]);
					}
				}
			}

			if ('tr' === Row.tagName.toLowerCase())
			{
				for ( var i = 0; i < Row.cells.length; i++)
				{
					var Cell = Row.cells[i];
					if (document.ELEMENT_NODE === Cell.nodeType)
					{
						var ColumnName = Cell.getAttribute('ColumnName');

						if (ColumnName)
						{
							if (Incoming.Cells[ColumnName])
							{
								// The assumption made by release 11 was that
								// any given tr
								// only contained 'unique' columns.. eg
								// DataGroupId was not in the row twice
								// Thus, Tablename was never compared and
								// cRecord.php never output the contents
								var NewCell = Incoming.Cells[ColumnName];
								if (NewCell.Error)
								{
									OperationErrorCode = 1;
									this.DisplayError(NewCell.Error);
								}
								else
								{
									this.CopyInputParameters(Cell, NewCell.Contents);
								}
							}
						}
					}
				}
				break; // prevent unecessary processing of the remaing cells,
				// No duplicate items per row in SP+
			}
			else if ('li' === Row.tagName.toLowerCase())
			{
				for (i = 0; i < Row.childNodes.length; i++)
				{
					var Cell = Row.childNodes[i];

					if (document.ELEMENT_NODE === Cell.nodeType && ((Cell.tagName == 'INPUT') || (Cell.tagName == 'SELECT') || (Cell.tagName == 'TEXTAREA')))
					{
						// var ColumnName = Cell.getAttribute('ColumnName');
						var DownToSyntax = Cell.getAttribute('DownToSyntax');
						var TableName = Cell.getAttribute('TableName');
						var PrimaryKey = Cell.getAttribute('PrimaryKey');
						if (!PrimaryKey || !DownToSyntax)
						{
							continue;
						}

						for ( var returnedRowIndex in Incoming.Cells)
						{
							if (Incoming.Cells[returnedRowIndex][DownToSyntax])
							{
								// lookup by column and table name because
								// multiple tables might have the same
								// columnname
								if (TableName == Incoming.Cells[returnedRowIndex][DownToSyntax]['RefTableName'])
								{
									// Match the primary key too
									if (PrimaryKey == Incoming.Cells[returnedRowIndex][DownToSyntax]['PrimaryKey'])
									{
										var NewCell = Incoming.Cells[returnedRowIndex][DownToSyntax];
										if (NewCell.Error)
										{
											OperationQueue.Clear();
											$(Cell).addClass('Invalid');
											alert(NewCell.Error);
											OperationErrorCode = 1;
											this.DisplayError(NewCell.Error);
										}
										else
										{
											this.CopyInputParameters(Cell, NewCell.Contents);
										}
										break;
									}
								}
							}
						}
					}
				}
			}
		}
		CheckOperationStatus(this, Incoming);
	};

	this.ResetNode = function()
	{
		this.DoReset();
	};

	this.DoReset = function()
	{
		if (!this.HasDataRows())
		{
			return;
		}

		if (this.AllowEditFields)
		{
			if (!this.HasDataRows())
			{
				return;
			}

			for ( var i = 0; i < this.DataRows.length; i++)
			{
				if ((this.DataRows[i].getAttribute('AccessLevel') == 'Full') || ('li' === this.DataRows[i].tagName.toLowerCase()))
				{
					ResetInputs(this.DataRows[i]);
				}
			}
		}
		var ErrorBox = this.GetErrorBox();
		if (ErrorBox)
		{
			ErrorBox.innerHTML = '';
		}
	};

	this.Refresh = function(UserUpdated)
	{
		this.UnregisterUpdates();

		//Copy all the attributes of ListTable under ListTableDiv for repainting the DOM on Ajax reply
		self.ListTableAtts = $(this.RootNode).find('.ListTableDiv .ListTable').prop('attributes');
		
		// Retain the floaing header attributes to being in floating after ajax call
		// This feature will be supressed once we enable...listHeader.sectionPositioned method call in ProcessRefreshResponse method below
		leica.pi.esm.floatingHeaders.listHeader.retainFloatingHeaderCloneAttr($(this.RootNode));
		
		var Params = 'ListName=' + this.ListName;

		if (UserUpdated)
		{
			Params += '&Page=' + this.Page + '&RecordsPerPage=' + this.RecordsPerPage + '&SortField=' + this.SortField.join(",") + '&SortOrder=' + this.SortOrder.join(",");
		}

		if (this.TableName != '')
		{
			Params += '&TableName=' + this.TableName;
		}

		if (this.Columns.length > 0)
		{
			Params += '&Columns[]=' + this.Columns[0];
			for ( var i in this.Columns)
			{
				if (i > 0)
				{
					Params += ',' + this.Columns[i];
				}
			}
		}

		if (this.AllowEditFields)
		{
			Params += '&AllowEditFields=1';
		}

		if (this.IsExpanded == true)
		{
			Params += '&IsExpanded=1';
		}
		else
		{
			Params += '&IsExpanded=0';
		}

		var TheList = this;
		var Receiver = new function()
		{
			this.Receive = function(http_request)
			{
				if ((http_request.readyState == 4) && (http_request.status == 200))
				{
					try
					{
						var Incoming = eval('(' + http_request.responseText + ')');
						CheckOperationStatus(TheList, Incoming);
						if (OperationErrorCode == 0)
						{
							TheList.ProcessRefreshResponse(Incoming);
						}
					}
					catch (e)
					{
						DisplayJsonError(e, http_request);
					}
				}
				else
				{
					SpectrumMessageBox('Loading, Please Wait...');
				}
			};
		};
		if (this.RefreshURL)
		{
			HTTPRequest(this.RefreshURL, 'POST', Params, Receiver);
		}
	};

	this.ProcessRefreshResponse = function(Data)
	{
		this.ImageCount = 0;
		this.LoadedImageCount = 0;

		this.TotalCount = Data.TotalCount;
		this.Page = Data.Page;
		this.RecordsPerPage = Data.RecordsPerPage;

		// Data.TotalCount = null;
		// Data.Page = null;

		var ListTableWrapper = this.ListTableDiv.children[0];
		while (ListTableWrapper.lastChild)
		{
			ListTableWrapper.removeChild(ListTableWrapper.lastChild);
		}

		/***********************************************************************
		 * NoFloat this.AnchorRows = new Array (); this.FloatingTables = new
		 * Array ();
		 **********************************************************************/
		this.DataRows = new Array();
		this.ChildRows = new Array();

		this.ListTable = document.createElement('TABLE');
		//Reassign the ListTable attributes
		self.$ListTable = $(this.ListTable);
		$.each(self.ListTableAtts, function(key, atts){ 
			self.$ListTable.attr(atts.name, atts.value);
		});
		ListTableWrapper.appendChild(this.ListTable);


		this.AdjustHeaders();

		if (this.TotalCount == 0)
		{
			var ListTableBody = this.ListTable.appendChild(document.createElement('TBODY'));
			ListTableBody.appendChild(document.createElement('TR'));

			var Column = document.createElement('TH');
			Column.innerHTML = 'No ' + this.PluralRecordsLabel + ' to display';
			ListTableBody.children[0].appendChild(Column);
		}
		else
		{
			var NumRows = Data.Rows.length;

			this.CreateHeaders(Data.Headers, 0, NumRows);

			var ListTableBody = this.ListTable.appendChild(document.createElement('TBODY'));

			// For each row
			for ( var row = 0; row < NumRows; row++)
			{
				var IncomingRow = Data.Rows[row];

				// Create a row
				var Row = ListTableBody.appendChild(document.createElement('TR'));
				for ( var attName in IncomingRow.Attributes)
				{
					if (attName == 'class')
					{
						Row.className = IncomingRow.Attributes[attName];
					}
					else
					{
						Row.setAttribute(attName, IncomingRow.Attributes[attName]);
					}
				}
				// IncomingRow.Attributes = null;

				if (hasClass(Row, 'DataRow'))
				{
					this.DataRows.push(Row);
				}
				else if (hasClass(Row, 'summary-row'))
				{
					this.DataRows.push(Row);
					this.AddCell(Row, IncomingRow.Cells['summary-row']);
				}
				else
				{
					// this.ChildRows.push(Row);
					continue;
				}

				// For each column of data
				for (var ColumnName in Data.Headers)
				{
					if (Data.Headers[ColumnName] == null)
					{
						// just a place holder, column not in this view instance
						continue;
					}

					if (IncomingRow.Cells[ColumnName])
					{
						this.AddCell(Row, IncomingRow.Cells[ColumnName]);
					}
					// else
					// This is probably a child row/listing which has only two cells

				}

				Data.Rows[row] = null;
			}

			Data.Rows = null;

			if (this.RecordCounter)
			{
				var Inputs = this.RecordCounter.getElementsByTagName('INPUT');
				var Input = Inputs[0];
				Input.value = this.RecordsPerPage;
			}

			/***************************************************************
			 * * javascript garbage collection should get this (and stuff
			 * above) for (var i in Data.Headers) { Data.Headers[i].Sorted =
			 * null; Data.Headers[i].CanSort = null; Data.Headers[i].Text =
			 * null; Data.Headers[i] = null; } Data.Headers = null;
			 **************************************************************/
		}

		this.SetPageNumbers();
		// NoFloat this.AlignHeaders ();
		this.LimitLength("field", 75);
		this.EnableControls();
		this.SetSelectedIds();
		this.UpdateBulkActions();
		this.RegisterUpdates();
		this.LoadImages();
		// this.CheckForExpansions();

		if (this.PALMode == false) {
			
			// Pass the section name to applay floating header for that section
			leica.pi.esm.floatingHeaders.listHeader.refresh(Data.ListName);
			
			// Jump to the beginning of specific section
			// this will supress the feature of listHeader.retainFloatingHeaderCloneAttr called above 
			leica.pi.esm.floatingHeaders.listHeader.sectionPositioned($(this.RootNode));
		}
		$(document).trigger('RenameAdvanceSearchResults', this.RootNode);

		Data = null;
		if (this.PALMode !== false) {
			$(window).scrollTop(0);
		}
	};


	this.AddCell = function(Row, CellDetails)
	{
		var Cell = Row.appendChild(document.createElement('TD'));

		var Contents = CellDetails.Contents;
		if (typeof (Contents) !== 'undefined' && Contents)
		{
			Cell.innerHTML += Contents;
		}

		// Set cell's attributes
		for (var attName in CellDetails.Attributes)
		{
			var attribute = CellDetails.Attributes[attName];
			if (attName == 'class')
			{
				Cell.className = CellDetails.Attributes[attName];
			}
			else
			{
				Cell.setAttribute(attName, CellDetails.Attributes[attName]);
			}
		}

		// Set cell's class
		if (CellDetails.Class)
		{
			Cell.className = Cell.className + ' ' + CellDetails.Class;
		}

		// Set image parameters
		var ImageElements = Cell.getElementsByTagName('IMG');
		for ( var l = 0; l < ImageElements.length; l++)
		{
			var Element = ImageElements[l];
			if (Element != undefined)
			{
				Element.ownerListObj = this;
				Element.onload = function()
				{
					this.ownerListObj.LoadedImage();
				};
				// Note: IE sometimes cannot access parentNode
				Element.onerror = function()
				{
								try
					{
						this.parentNode.innerHTML = "";
					}
					catch (e)
					{
					}
					this.ownerListObj.LoadedImage();
				};
				this.ImageCount++;
			}
		}
	}

	this.LoadImages = function()
	{
		if (FunctionExists(ImageLoad))
		{
			if (!this.HasDataRows())
			{
				return;
			}
			for ( var i = 0; i < this.DataRows.length; i++)
			{
				ImageLoad(this.DataRows[i]);
			}
		}
	};

	this.LoadedImage = function()
	{
		this.LoadedImageCount++;

		/***********************************************************************
		 * *NoFloat if (this.LoadedImageCount >= this.ImageCount)
		 * this.AlignHeaders ();
		 **********************************************************************/
	};

	/**
	this.CheckForExpansions = function()
	{
		for ( var i = 0; i < this.ChildRows.length; i++)
		{
			var Row = this.ChildRows[i];
			var ChildListName = Row.getAttribute('ChildListName');
			if (ChildListName)
			{
				if (Row.getAttribute('ChildExpanded') == 'true')
				{
					ToggleList(Row, true);
				}
			}
		}
	};
	**/

	/***************************************************************************
	 * ** NoFloat this.AlignHeaders = function () { var HeaderOffset = 0;
	 * 
	 * if (isset (this.AnchorRows)) { for (var i = 0; i <
	 * this.AnchorRows.length; i++) { var TopOffset; if
	 * (this.AnchorRows[i].offsetTop > this.ListTableDiv.scrollTop) TopOffset =
	 * this.AnchorRows [i].offsetTop; else TopOffset =
	 * this.ListTableDiv.scrollTop; TopOffset -= (this.ListTable.offsetHeight +
	 * HeaderOffset);
	 * 
	 * if (this.FloatingTables.length > i) { this.FloatingTables[i].style.top =
	 * TopOffset + 'px'; this.FloatingTables[i].style.width =
	 * this.ListTable.offsetWidth + 'px';
	 * 
	 * HeaderOffset += this.FloatingTables[i].offsetHeight;
	 * 
	 * for (var j = 0; j < this.AnchorRows[i].cells.length; j++)
	 * this.FloatingTables [i].rows[0].cells[j].style.width = (Math.max
	 * (this.AnchorRows[i].cells[j].clientWidth - 8, 0)) + 'px'; } } } }
	 **************************************************************************/

	// cList
	this.CreateHeaders = function(Headers, FirstIndex, LastIndex)
	{
		var Thead = document.createElement('thead');
		var HeaderRow = document.createElement('TR');
		
		var fixedColumnClass = 'fixed-column';
		var isFirstColumn  = true;
		
		this.HeaderRow = HeaderRow;
		HeaderRow.className = 'HeaderRow';

		for ( var HeaderName in Headers)
		{
			var Header = Headers[HeaderName];

			// HeaderRow.innerHTML += Header.Text;
			var Cell = document.createElement('TH');
			// retain the class name for checkbox to maintain the fixed width
			if (isFirstColumn && HeaderName === 'BulkCheck')
			{
				Cell.setAttribute('class', fixedColumnClass);
				isFirstColumn = false;
			}
			Cell.innerHTML += Header.Contents;
			if (Header.className !== undefined)
			{
				Cell.setAttribute('class', Header.className);
			}
			if (Header.locked === 'true')
			{
				Cell.setAttribute('locked', 'true');
			}
			if (Header.align !== undefined && (Header.align != ''))
			{
				Cell.setAttribute('align', Header.align);
			}
			if (Header.width !== undefined && (Header.width != ''))
			{
				Cell.setAttribute('width', Header.width);
			}
			HeaderRow.appendChild(Cell);
		}

		this.ListTable.appendChild(Thead);
		Thead.appendChild(HeaderRow);
	};

	// cList
	this.SetPageNumbers = function ()
	{
		if ((false == this.HasPaginator) || ("undefined" === typeof this.HasPaginator))
		{
			return;
		}

		// Set the Paginator input value.  See Paginator.js for the rest of the section.
		this.Paginator.value = this.Page;

		var MaxPages = Math.ceil (parseInt (this.TotalCount) / parseInt (this.RecordsPerPage));
		if (MaxPages == 0)
		{
			// Hide paginator
			this.Paginator.parentNode.style.display = 'none';
		}
	};

	// cList
	this.EnableControls = function()
	{
		if (this.BulkEnabled)
		{
			/*******************************************************************
			 * NoFloat if (this.AllowBulkSelect) { // Uncheck all 'Check All'
			 * boxes for (var i = 0; i < this.FloatingTables.length; i++) { var
			 * Row = this.FloatingTables[i].children[0].children[0]; var
			 * CheckBox = this.GetCheckBox(Row, 'BulkSelectBox'); if (CheckBox)
			 * CheckBox.checked = false; } }
			 ******************************************************************/

			// Enable all bulk tasks that don't require an access level
			for ( var i = 0; i < this.BulkTasks.length; i++)
			{
				if (this.BulkTasks[i].getAttribute('MinAccessLevelRequired') == 'None')
				{
					removeClass(this.BulkTasks[i], 'Disabled');
				}
			}
		}

		if (this.HasPaginator)
		{
			this.Paginator.disabled = false;
			this.PreviousLink.className = (this.Page > 1) ? '' : 'Disabled';
			this.NextLink.className = (parseInt(this.Page) < (this.TotalCount / this.RecordsPerPage)) ? '' : 'Disabled';
		}

		if (this.RecordCounter)
		{
			this.RecordCounter.disabled = false;
		}
	};

	// cList
	this.RegisterUpdates = function()
	{
		if (typeof (UpdateField) !== 'undefined')
		{
			// This function (found in FieldUpdater.js) exists for auto updating
			var Cells = this.ListTable.getElementsByTagName('TD');
			for ( var i = 0; i < Cells.length; i++)
			{
				var Field = null;
				var AutoUpdate = Cells[i].getAttribute('AutoUpdate');

				if (AutoUpdate == 'true')
				{
					Field = new UpdateField(Cells[i]);
					Field.Register();
				}

				Cells[i].UpdateField = Field;
			}

			// NoFloat FieldUpdater.AddListener (this, 'AlignHeaders');
		}
	};

	// cList
	this.UnregisterUpdates = function()
	{
		if (typeof (UpdateField) !== 'undefined')
		{  
			var Cells = this.ListTable.getElementsByTagName('TD');
			for ( var i = 0; i < Cells.length; i++)
			{
				var Field = Cells[i].UpdateField;
				if (Field)
				{
					Field.Unregister();
					delete Field;
				}
			}
		}
	};

	// cList
	this.OnResize = function()
	{
		if (this.StretchWidth)
		{
			// Align all div's right side to be within page boundaries
			// var WindowWidth = document.body.clientWidth;
			// this.RootNode.style.width = WindowWidth - GetLeft(this.RootNode)
			// - 15;
		}
		// NoFloat this.AlignHeaders ();
	};

	// cList
	this.SetSelectedIds = function()
	{
		if (this.AllowBulkSelect == false)
		{
			return;
		}

		// Move all selected Ids from the last visited page to the hidden list
		for ( var id in this.SelectedIds)
		{
			this.HiddenIds[id] = this.SelectedIds[id];
		}
		for ( var id in this.SelectedImageIds)
		{
			this.HiddenImageIds[id] = this.SelectedImageIds[id];
		}

		this.SelectedIds = new function()
		{
		};
		this.SelectedImageIds = new function()
		{
		};

		if (!this.HasDataRows())
		{
			return;
		}

		// Move all previously seleced Ids from the new page to this page's list
		for ( var i = 0; i < this.DataRows.length; i++)
		{
			var Row = this.DataRows[i];
			var Id = Row.getAttribute('Ids');
			var ImageId = Row.getAttribute('ImageIds');

			var CheckBox = this.GetCheckBox(Row, 'Ids[]');
			if (CheckBox == null)
			{
				continue;
			}

			if (this.HiddenIds[Id])
			{
				this.SelectedIds[Id] = this.HiddenIds[Id];
				delete this.HiddenIds[Id];

				CheckBox.checked = true;

				if (ImageId > 0)
				{
					if (this.HiddenImageIds[ImageId])
					{
						this.SelectedImageIds[ImageId] = this.HiddenImageIds[ImageId];
						delete this.HiddenImageIds[ImageId];
					}
				}
			}

			// the page may be loaded with some check rows. Make sure they are
			// accounted for
			if (CheckBox.checked)
			{
				var RowAccessLevel = GetLowestAccessLevel(Row.getAttribute('AccessLevel'), Row.getAttribute('DataGroupAccessLevel'));
				this.SelectedIds[Id] = RowAccessLevel;
				if (ImageId > 0)
				{
					this.SelectedImageIds[ImageId] = RowAccessLevel;
				}

			}
		}

		this.SavedHiddenIds = this.HiddenIds;
		this.SavedHiddenImageIds = this.HiddenImageIds;

		this.DetermineBulkCheck();

		this.SetHiddenSelect();
	};

	// cList
	this.SetHiddenSelect = function()
	{
		var CountSelectedIds = this.Count(this.HiddenIds);

		if (undefined === this.HiddenSelectCount)
		{
			return;
		}

		this.HiddenSelectCount.innerHTML = CountSelectedIds;

		if (CountSelectedIds > 0)
		{
			this.HiddenSelectCheckbox.checked = true;
			this.HiddenSelectRow.style.display = '';
		}
		else
		{
			this.HiddenSelectCheckbox.checked = false;
			this.HiddenSelectRow.style.display = 'none';
		}
	};

	// cList
	this.GetSelectCount = function()
	{
		var NumSelects = this.Count(this.SelectedIds) + this.Count(this.HiddenIds);
		return NumSelects;
	};

	// cList
	this.AutoViewSelectedImages = function()
	{
		// this function is called when the page is loaded and
		// whenever the "AutoView" check box is checked or unchecked.

		// if there's an AutoView checkbox, then see if it's checked
		// and auto view selected images.
		if (this.AutoViewCheckBox)
		{
			SetCookie("AutoViewSelectedImages", (this.AutoViewCheckBox.checked ? 1 : 0), 365);
			// if checked, then figure out which images to open.
			if (this.AutoViewCheckBox.checked)
			{
				// if there is at least one record selected
				if (this.GetSelectCount() > 0)
				{
					// bulk view
					this.BulkAction(this.AutoViewCheckBox);
				}
			}
		}
	};

	// cList
	this.UpdateRowAltClasses = function()
	{
		// this function should be called whenever a row is added or deleted
		// on the clientside. It will update the CSS class name for each row
		// such that they alternate from "DataRow" to "DateRow Alt"
		var DataRowIndex = 0;
		for (var r = 0; r < this.ListTable.rows.length; r++)
		{
			var Row = this.ListTable.rows[r];

			if (Row.className.indexOf("DataRow") >= 0)
			{
				// this is a data row
				var NewClass = (DataRowIndex % 2 == 1) ? "DataRow" : "DataRow Alt";

				// replace the existing "DataRow Alt" or "DataRow"
				if (Row.className.indexOf("DataRow Alt") >= 0)
				{
					Row.className = Row.className.replace("DataRow Alt", NewClass);
				}
				else
				{
					Row.className = Row.className.replace("DataRow", NewClass);
				}

				DataRowIndex++;
			}

		}
	};

	// cList
	this.BulkViewWithImageScopeOrBrowser = function()
	{
		// view multiple slides in ImageScope. If ImageScope
		// is not installed then view in browser.

		var fForm = this.BulkForm;

		var Viewer = ChooseViewer(null);
		if (Viewer == IMAGESCOPE)
		{
			// request a SIS file
			NeedCheck = true;
			// location.host includes :port unless port is 80, in which case it
			// is the same as location.hostname
			var Cmd = 'BulkImageScopeView&HostName=' + location.host;
			RequestBulkAction(Cmd, '', fForm);
			NeedCheck = false;
		}
		else if (Viewer == WEBVIEWER)
		{
			// Launch WebViewer which is also known as uScope  
			// open all of the images in a single DST/uScope
			var Ids = this.GetImageIdsToView(fForm);
			if (Ids.length > 0)
			{
				window.open('eSlideTray.php?ImageIds=' + Ids.join(','), WEBVIEWER);
			}
		}
		else if (Viewer == WEBSCOPE)
		{
            // Launch WebScope
			var Ids = this.GetImageIdsToView(fForm);
			for(var i = 0; i < Ids.length; i++)
			{
				// open each image in a separate WebScope window
				window.open('/ViewImage.php?ImageId=' + Ids[i]);
			}
		}
		qPressed = false;
	};

	// cList
	// return array of image ids contained in a form
	this.GetImageIdsToView = function(fForm)
	{
		var Ids = new Array();
		$(fForm).find('input[name="ImageIds[]"][value!=-1]').each(function()
		{
			Ids.push($(this).attr('value'));
		});
		return Ids;
	};

	// cList
	this.LimitLength = function(className, len)
	{
		var hasClassName = new RegExp("(?:^|\\s)" + className + "(?:$|\\s)");
		var allElements = document.getElementsByTagName("*");

		var element;
		// if using cluetips, then set title split character
		// cluetip tooltips have a title line and the actual tooltip text
		// these two fields are delimited by a '|' character.
		var clueTipTitleDelimiter = typeof ($('*').cluetip) == 'function' ? '|' : '';

		for ( var i = 0; (element = allElements[i]) != null; i++)
		{
			var elementClass = element.className; // this must be an array for indexOf to be defined in the next line
			if (elementClass && (undefined !== elementClass.indexOf) && (elementClass.indexOf(className) != -1) && hasClassName.test(elementClass))
			{
				currLen = element.innerHTML.length;
				if (currLen > len)
				{
					// Make sure innerHTML does not contain any textarea tags
					for ( var ii = 0; ii < element.childNodes.length; ii++)
					{
						if (element.childNodes[ii].tagName == "TEXTAREA")
						{
							return;
						}
					}
					// set a tooltip which is the entire innerHTML prior to
					// being truncated
					if ((element.title == '') && (element.innerHTML != ''))
					{
						element.title = clueTipTitleDelimiter; // default to no
						// title in the
						// clue tooltip
						// get the index of this element in the tr
						var idx = $(element).closest('.DataRow').find('td').index(element);
						if (idx > -1)
						{
							// get the column headers
							var hdrs = $(element).closest('.ListTable').find('.HeaderRow').first().find('th');
							if (hdrs.length > idx)
							{
								// get column name from header cell
								var colName = hdrs.eq(idx).text();
								if (colName != '')
								{
									colName = colName.replace(' \u2193', '');
									colName = colName.replace(' \u2191', '');
									element.title = colName + clueTipTitleDelimiter; // set
									// column
									// name
									// as
									// tooltip
									// title
								}
							}
						}
						element.title += element.innerHTML;
					}
					element.innerHTML = element.innerHTML.substr(0, len) + '...';
				}
				else
				{
					$(element).removeClass(className);
				}
			}
		}
	};
}

/**
 * This code changes the --ALL--  option to the first found "equal to" or "LIKE"
 * when the user types something into the text box without an existing entry
 * @param TableName 
 * @param ColumnName
 */
function SetSearchOperator(TableName, ColumnName)
{	
	// As of rel 12 (Spectrum Healthcare), there can multiple Search Forms, each
	// on a separate tab,
	// so find the visible one, presumably it is on the active tab
	var visibleSearchForms = $('[name=SearchForm]').filter(':visible');
	for ( var k = 0; k < visibleSearchForms.length; k++)
	{		
		var visibleSearchForm = visibleSearchForms[k];	
		var length = $(visibleSearchForm).find('input[name="FieldName[]"]').length;
		for ( var i = 0; i < length; i++)
		{
			var visibleTableName = $(visibleSearchForm).find('input[name="Table[]"]')[i].value;
			var visibleFieldName = $(visibleSearchForm).find('input[name="FieldName[]"]')[i].value;		
			var visibleFieldOperator = $($(visibleSearchForm).find('select[name="FieldOperator[]"]')[i]).val();		
			var visibleFieldOperatorOptions = $(visibleSearchForm).find('select[name="FieldOperator[]"]')[i].options;		

			if ((visibleTableName == TableName) && (visibleFieldName == ColumnName))
			{
				if (visibleFieldOperator == 'All')
				{
					for ( var j = 0; j < visibleFieldOperatorOptions.length; j++)
					{
						if (visibleFieldOperatorOptions[j].value == '=')
						{
							visibleFieldOperatorOptions[j].selected = true;
							break;
						}
						else if (visibleFieldOperatorOptions[j].value == 'LIKE')
						{
							visibleFieldOperatorOptions[j].selected = true;
							break;
						}
					}
				}
				break;
			}
		}
	}
}

var VisibleList = null;
function ShowSearchParamSelection(ePlus, optionsListName)
{
	var List = document.getElementsByName(optionsListName)[0];

	var eElement = ePlus.parentNode;
	var Top = eElement.offsetTop;
	var Left = eElement.offsetLeft;
	while ((eElement = eElement.offsetParent) != null) // Find the top, left
	// corner of the plus
	// image clicked
	{
		Top += eElement.offsetTop;
		Left += eElement.offsetLeft;
	}

	// Place and show the list div
	List.style.display = 'block';
	List.style.top = Top + ePlus.clientHeight;
	List.style.left = Left;

	// check if previosly opened filter box then close it
	if (VisibleList != null)
	{
		var ThisListTable = document.getElementById(VisibleList);
		ThisListTable.style.display = 'none';
	}

	VisibleList = optionsListName; // Set it to the list's name so we only
	// allow one to be open at a time

	var ListHeight = 4; // Magic number to avoid having unnessecary scroll bars
	// in IE.
	var eOptionsListDivs = List.getElementsByTagName("DIV");
	for ( var i = 0; i < eOptionsListDivs.length; i++)
	{
		if (eOptionsListDivs[i].style.display != 'none')
		{
			ListHeight += eOptionsListDivs[i].offsetHeight + 1; // Magic
			// number
			// to
			// get
			// past
			// the
			// inaccesible
			// padding
			// value
		}
	}

	if (ListHeight > 250)
	{
		ListHeight = 250; // Maximum options list size
	}

	// Temp fix for IE error, looking into why 'List is null or not an object'
	// at this point
	// List.style.height = ListHeight + 'px';
}

function HideSearchParamSelection()
{
	// Hide all lists except the one that matches the name stored in VisibleList
	// As of rel 12 (Spectrum Healthcare), there can multiple Search Forms, each
	// on a separate tab,
	// so find the visible one, presumably it is on the active tab
	var HierarchyParent = $('[id=HierarchyParent]').filter(':visible');
	if (HierarchyParent.length > 0)
	{
		HierarchyParent = HierarchyParent[0];
		for ( var i = 0; i < HierarchyParent.childNodes.length; i++)
		{
			// TODO (cc) - this looks like it can be replaced with a more specific / efficient jQuery selector, maybe something like
			// $(`#HierarchyParent`).filter(`:visible`).find(`.SubSection > .OptionsList:not([name=${VisibleList}])`).style('display', 'none');
			// I don't know where this gets used though so wouldn't want to change it today...
			if (hasClass(HierarchyParent.childNodes[i], 'SubSection'))
			{
				var SubSection = HierarchyParent.childNodes[i];
				for ( var j = 0; j < SubSection.childNodes.length; j++)
				{
					if (hasClass(SubSection.childNodes[j], 'OptionsList'))
					{
						var OptionsList = SubSection.childNodes[j];
						if (OptionsList.getAttribute('name') != VisibleList)
						{
							OptionsList.style.display = 'none';
						}

					}
				}
			}
		}
	}
	VisibleList = null;

}

function AddSearchParam(eSelection, optionsTableId)
{
	var Table = document.getElementById(optionsTableId);

	// 'Remove' the element from the unused list by hiding it
	eSelection.style.display = 'none';
	eSelection.parentNode.style.display = 'none';

	// Find the newly activated row
	for ( var i = 0; i < Table.rows.length; i++)
	{
		if (eSelection.getAttribute('name') == Table.rows[i].getAttribute('name'))
		{
			var InputCell = Table.rows[i].cells[1];

			Table.rows[i].style.display = ''; // 'Create' the parameter row by
			// showing it

			// Enable the input elements
			for ( var j = 0; j < InputCell.childNodes.length; j++)
			{
				if (InputCell.childNodes[j].disabled == true)
				{
					InputCell.childNodes[j].disabled = false;
				}
			}
		}
	}
}

function RemoveSearchParam(eMinus, optionsListName)
{
	var Cell = eMinus.parentNode;
	var Row = Cell.parentNode;
	var Table = Row.parentNode.parentNode;
	var OptList = document.getElementsByName(optionsListName)[0]; // Table.previousSibling;

	Row.style.display = 'none'; // 'Remove' the parameters by hiding them
	Cell = Row.getElementsByTagName("TD")[1]; // Cell.nextSibling;

	// Disable the input elements
	for ( var i = 0; i < Cell.childNodes.length; i++)
	{
		if (Cell.childNodes[i].disabled == false)
		{
			Cell.childNodes[i].disabled = true;		
			// When closing the filter, the parameters values need to reset as well
			// Also need to reset the value for the search params that is being removed
			if (Cell.childNodes[i].name == 'FieldValue[]' || Cell.childNodes[i].name == 'FieldValue2[]')
			{
				Cell.childNodes[i].value = '' ;
			}
		}
		// also when closing the filter all of the previous error tags should be removed as well
		// remove all of the error tags for this search param   
		if (Cell.childNodes[i].id == 'shortError')
		{					
			shortError = Cell.childNodes[i];
			shortError.parentNode.removeChild( Cell.childNodes[i]);
		}
	}

	// 'Create' the unused list entry by showing it again
	for ( var i = 0; i < OptList.childNodes.length; i++)
	{
		if ((OptList.childNodes[i].nodeName == "DIV") && (OptList.childNodes[i].getAttribute('name') == Row.getAttribute('name')))
		{
			OptList.childNodes[i].style.display = '';
		}
	}
}

function EnableBulk(BulkTask)
{
	BulkTask.style.color = '';
}

function DisableBulk(BulkTask)
{
	addClass(BulkTask, 'Disabled');

	// I cannot get css: A.Disabled to work on nested lists, so change color
	// here
	BulkTask.style.color = 0x999999;
	var SelectNode = document.getElementById(BulkTask.id + 'SelectDiv');
	if (SelectNode != null)
	{
		// make div invisible
		SelectNode.style.display = 'none';
	}
}

function DoBulkAction(Parms)
{
	var ListName = Parms.substr(0, Parms.indexOf('.'));
	var List = GlobalList.Lists[ListName];
	var Form = List.BulkForm;

	var Action = Parms.substr(Parms.indexOf('.') + 1);

	var ParmArray = new Array();
	AddExtraParms(ParmArray);
	var Parms = ParmArray.join('&');

	RequestBulkAction(Action, Parms, Form);
}

function RequestBulkAction(sCommand, Parms, fForm)
{
	// submit the bulk form
	fForm.action = '/BulkAction.php?Command=' + sCommand;
	if (Parms != '')
	{
		fForm.action += '&' + Parms;
	}
	fForm.submit();
}

/**
function ToggleChildList(Img)
{
	var ParentRow = Img.parentNode.parentNode;
	var ChildRow = ParentRow.nextSibling;
	while (ChildRow && (document.TEXT_NODE == ChildRow.nodeType))
	{
		ChildRow = ChildRow.nextSibling;
	}
	ToggleList(ChildRow, false);
}
**/

function ToggleList(Row, DoExpand)
{
	var ChildListName = Row.getAttribute('ChildListName');
	if (ChildListName)
	{
		var Cell = FindElementWithClass(Row, 'ChildCell');
		var List = GlobalList.GetList(ChildListName);
		if (List == null)
		{
			List = CreateCList(ChildListName, Cell);
		}
		List.ParentNode = Cell;
		Cell.appendChild(List.RootNode);
		List.ToggleList(DoExpand);
	}
}

function BulkCheck(Box)
{
	var ListName = GetListName(Box);
	if (ListName)
	{
		var List = GlobalList.GetList(ListName);
		if (List)
		{
			List.BulkCheck(Box);
		}
	}
}

function OnCheck(Box)
{
	var ListName = GetListName(Box);
	if (ListName)
	{
		var List = GlobalList.GetList(ListName);
		if (List)
		{
			List.OnCheck(Box);
		}
	}
}

function ColumnSort(Event, Element)
{
	var ListName = GetListName(Element);

	if (ListName)
	{
		var List = GlobalList.GetList(ListName);
	  
		if (List)
		{
			
			var TableName=List.TableName;
			
			if ("undefined" != typeof StartMulti)
			 {
				if (StartMulti == false) 
				{
					CheckSort(TableName,List,Event, Element);  
				}
				else
				{
					LoadSort(List, TableName, Event, Element);  
				}
				
			 }

		}
	}
}

function LoadSort(List, TableName, Event, Element)
{
	var SortField = Element.getAttribute ('Key');
	var SortOrder = Element.getAttribute ('NewOrder');      
	var Message = Element.getAttribute ('Message');  
	
	
	if ("undefined" != typeof MultiSortOn)
	{
		if ((Message != '') && (Message != null) && (MultiSortOn == true))
		{
			if (confirm(Message) == false)
			{
				return;
			}
		}

	}            
					   
	if ('function' == typeof SaveMultiSortColumnData)
	{
		SaveMultiSortColumnData(TableName,SortField,SortOrder);
	}
		List.Sort(Element, Event.ctrlKey);
}

function ColumnSortUpdate(Event, Element)
{

	var ListName = GetListName(Element);

	if (ListName)
	{
		var List = GlobalList.GetList(ListName);

		if (List)
		{
			if (isset(Event))
			{
				List.Sort(Element, (isset(Event.ctrlKey) ? Event.ctrlKey : false));
			}
			else
			{
				List.Sort(Element, false);
			}
		}
	}
}

function ListAction(Link)
{
	if (hasClass(Link, 'Disabled'))
	{
		return false;
	}
	var ListName = GetListName(Link);
	if (ListName)
	{
		var List = GlobalList.GetList(ListName);
		if (List)
		{
			List.BulkAction(Link);
		}
	}
}

function ListActionOption(SelectElement)
{
	var ListName = GetListName(SelectElement);
	if (ListName)
	{
		var List = GlobalList.GetList(ListName);
		if (List)
		{
			List.BulkActionOption(SelectElement);
		}
	}
}

function OnHidden(Element)
{
	var ListName = GetListName(Element);
	if (ListName)
	{
		var List = GlobalList.GetList(ListName);
		if (List)
		{
			List.OnHidden(Element);
		}
	}
}

function PageCheck(element, event)
{
	var key = event.keyCode || event.which;
	if (key == 13)
	{
		// Ensure we execute the page change, even if some other element grabs the CR
		GoToPage(element);
		return true;
	}
	return CheckForInteger(event);
}

function GoToPage(Element)
{
	var ListName = GetListName(Element);
	if (ListName)
	{
		var List = GlobalList.GetList(ListName);
		if (List)
		{
			List.GoToPage(Element.value);
		}
	}
}

function SetRecordsPerPage(Element)
{
	var ListName = GetListName(Element);
	if (ListName)
	{
		var List = GlobalList.GetList(ListName);
		if (List)
		{
			var RecordsPerPage = ForceToNumber(Element.value, 1, 100, 1);
			Element.value = RecordsPerPage;
			List.RecordsPerPage = RecordsPerPage;
			List.Refresh(true);
		}
	}
}

function GetListName(Element)
{
	while (Element)
	{
		if ((typeof Element.getAttribute == 'function') || (typeof Element.getAttribute == 'object')) // IE
		{
			if (Element.getAttribute('clistname'))
			{
				return Element.getAttribute('clistname');
			}
		}
		Element = Element.parentNode;
	}
	return null;
}

function CreateCList(Name, ParentNode)
{
	// Get the template name by removing any appended digits to the clist name
	var List = new cList(Name);
	var BaseList = Name.replace(/\d/g, '') + 'Template';
	var SrcList = GlobalList.Lists[BaseList];
	List.Copy(SrcList, ParentNode);
	return List;
}

/**
 * Copy attributes from a tag
 */
function CopyAttributes(SrcElement, DstElement)
{
	// .outerHTML not supported by FF and FF method causes list to diplay incorrectly in IE
	if (navigator.appName == "Microsoft Internet Explorer")
	{
		var str = SrcElement.outerHTML;
		var pEndOfElement = str.indexOf('>');
		var pStart = 1;
		var pEqual, pEnd;
		var attName;
		while (true)
		{
			pEqual = str.indexOf('=', pStart);
			if ((pEqual < 0) || (pEqual > pEndOfElement))
			{
				break;
			}
			pStart = str.lastIndexOf(' ', pEqual) + 1;
			attName = str.slice(pStart, pEqual);
			pStart = pEqual + 1;
			var chr = str.charAt(pStart);
			if (chr == '"' || chr == "'")
			{
				pStart++;
				pEnd = str.indexOf(chr, pStart);
				if (pEnd > pEndOfElement)
				{
					// This means there is a '>' in the quoted attribute value, find the next '>' past the quotes
					pEndOfElement = str.indexOf('>', pEnd);
				}
			}
			else
			{
				pEnd = str.indexOf(' ', pStart);
			}
			if ((pEnd < 0) || (pEnd > pEndOfElement))
			{
				pEnd = pEndOfElement;
			}
			if (attName != 'type' && attName !== '')
			{
				var attribute = str.slice(pStart, pEnd);
				// IE8 does not always xmldecode &amp;, and setAttribute() will not accept the encoded version
				//  therefore manually decode it here
				attribute = attribute.replace(/&amp;/g, '&');
				DstElement.setAttribute(attName, attribute);
			}
			if (pEnd >= pEndOfElement)
			{
				break;
			}
			pStart = pEnd + 1;
		}
	}
	else
	{
		for ( var i = 0; i < SrcElement.attributes.length; i++)
		{
			if (SrcElement.attributes[i].name != 'type' && SrcElement.attributes[i].name !== '')
			{
				DstElement.setAttribute(SrcElement.attributes[i].name, SrcElement.attributes[i].value);
			}
		}
	}
}

function CopyElement(SrcElement, RootName)
{
	var NewElement;
	var Tag = SrcElement.nodeName;

	if (Tag == '#text')
	{
		NewElement = document.createTextNode(SrcElement.nodeValue);
		return NewElement;
	}

	NewElement = document.createElement(Tag);

	if (SrcElement.name)
	{
		NewElement.name = SrcElement.name;
	}
	if (SrcElement.id)
	{
		NewElement.id = SrcElement.id;
	}
	if (SrcElement.disabled)
	{
		NewElement.disabled = SrcElement.disabled;
	}
	NewElement.className = SrcElement.className;
	NewElement.setAttribute('rootName', RootName);

	CopyAttributes(SrcElement, NewElement);

	// Transfer style
	for ( var attName in SrcElement.style)
	{
		if (attName != 'font')
		{
			var attribute = SrcElement.style[attName];
			if ((typeof (attribute) != 'object') && (typeof (attribute) != 'number'))
			{
				NewElement.style[attName] = attribute;
			}
		}
	}

	// Contents
	if (Tag == 'INPUT')
	{
		if (navigator.appName == "Microsoft Internet Explorer")
		{
			// This is necessary in IE to set the type of the input.
			// Perhaps this should be done above for everything?
			try
			{
				NewElement = SrcElement.cloneNode(false);
				NewElement.outerHTML = SrcElement.outerHTML;
			}
			catch(ex)
			{
			}
		}
		else
		{
			NewElement.innerHTML = SrcElement.innerHTML;
		}
		NewElement.type = SrcElement.type;

		NewElement.onchange = SrcElement.onchange;
		// NewElement.type = SrcElement.type;
		NewElement.onkeypress = SrcElement.onkeypress;
		NewElement.style.width = SrcElement.style.width;
		NewElement.name = SrcElement.name;
		NewElement.value = SrcElement.value;
		if (SrcElement.maxLength > 0)
		{
			NewElement.maxLength = SrcElement.maxLength;
		}
	}
	else if (Tag == 'SELECT')
	{
		NewElement.innerText = SrcElement.innerText;
	}
	else if (Tag == 'SCRIPT')
	{
		return null;
	}
	else if (SrcElement.children.length == 0)
	{
		NewElement.innerHTML = SrcElement.innerHTML;
	}

	// Append Children
	var SrcChild = SrcElement.children[0];
	while (SrcChild)
	{
		var Child = CopyElement(SrcChild, RootName);
		if (Child)
		{
			NewElement.appendChild(Child);
		}
		SrcChild = SrcChild.nextSibling;
	}

	if (Tag == 'A')
	{
		NewElement.setAttribute('FormAction', SrcElement.getAttribute('FormAction'));
		if (SrcElement.attributes['onclick'])
		{
			// NewElement.onclick = SrcElement.onclick;
			NewElement.onclick = function()
			{
				ListAction(NewElement);
				return false;
			};
		}
	}
	else if (Tag == 'SELECT')
	{
		if (SrcElement.attributes['onchange'])
		{
			var Operation = SrcElement.attributes['onchange'].value;
			if (Operation.substring(0, 16) == 'ListActionOption')
			{
				NewElement.onchange = function()
				{
					ListActionOption(NewElement);
					return false;
				};
			}
			else if (Operation.substring(0, 8) == 'GoToPage')
			{
				NewElement.onchange = function()
				{
					GoToPage(NewElement);
					return false;
				};
			}
		}
	}
	else if (Tag == 'OPTION')
	{
		NewElement.selected = SrcElement.selected;
	}

	return NewElement;
}

// For some reason some attribute strings are converted to DispHTMLDOMAttibute
// objects during setAttribute()
function GetAttributeString(Element, AttName)
{
	var Attribute = Element.attributes[AttName];
	while (typeof (Attribute) == 'object')
	{
		if (Attribute == null)
		{
			return "";
		}
		Attribute = Attribute.nodeValue;
	}
	return Attribute;
}

function CheckKeyCode(item,event){

	var key = (event.which ? event.which : event.keyCode); 
	if (!(key == 8 || key == 13 || (key >= 48 && key <= 57))) return false; 
	// note, IE8 needs event.returnValue set to false, just returning false from this function does not
	// prevent event propagation in IE8 (also note, event.stopPropagation is not supported in IE8)
	else if (key == 13) { item.blur (); if (!event.stopPropagation)event.returnValue=false; return false; }
}

/* START of Hover Thumbnail Image Clip Fix - FB#22899 **/
/* Handle the hoverpopup based on mouse position **/
$(document).on("mouseenter", '.thumbnailDiv', function(mousePos){
	var $this = $(this);
	var $parents = $this.parents().closest('.ListTableDiv');
	if ($parents.length == 0)
		return;
	var $visibleParents = $parents.filter(':visible');
	if ($visibleParents.length == 0)
		return;
	if($visibleParents){ //do only for List Table
		var $visiblePopup = $this.find('.hoverpopup');
		var scrollPos = $(window).scrollTop();
		var baseHeight = $this.height();
		
		//the minimum space required to show the thumbnail
		var minHeight = $visiblePopup.height();

		//set the reference point
		var refPos = $visibleParents.position().top;
			  
		//tweak for floating header
		if(scrollPos > refPos) refPos = 0;
		
		//Calculate the distance of the mouseover from it's reference point, making sure sticky/floating header is also addressed
		var vDistance = (scrollPos > refPos) ? Math.abs(mousePos.pageY - (scrollPos + refPos)) : Math.abs(mousePos.pageY - refPos);
		
		//Reset css top value
		if($visibleParents.height() < (minHeight * 2)) //when list table height is minimum
			$visiblePopup.css({
				'top' : '-'+((minHeight - baseHeight)+25)+'px' //display thumbnail close to the base image with 25px margin
			});
		else if (vDistance < (minHeight * 1.5))
			$visiblePopup.css({
				'top' : '0' //display thumbnail slightly beneath the base image 
			});
		else 
			$visiblePopup.css({
				'top' : '-'+minHeight+'px' //display thumbnail slightly above the base image
			});
	}
});
/* END of Hover Thumbnail Image Clip Fix - FB#22899 ***/